import React, { useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchHedgeFund } from '../../../../api/tickersApi';
import { Row, Col, Card, Space, Spin, Switch } from 'antd';
import HedgeFundTable from './HedgeFundTable';
import NavTrail from '../../../../layouts/NavTrail';


const HedgeFund = () => {
  const { hedgefundName } = useParams();
  const dispatch = useDispatch();
  const hedgeFund = useSelector((state) =>
    state.tickers.hedgeFunds.find((fund) => fund.name === hedgefundName)
  );
  const status = useSelector((state) => state.tickers.status);
  const error = useSelector((state) => state.tickers.error);

  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    if (!hedgeFund || !hedgeFund.current_portfolio) {
      dispatch(fetchHedgeFund(hedgefundName));
    }
  }, [dispatch, hedgefundName, hedgeFund]);

  if (status === 'loading') {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Spin tip={`Loading ${hedgefundName}...`} size="large" />
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px', color: 'red' }}>
        <h3>Error:</h3>
        <p>{error || `Failed to load ${hedgefundName}.`}</p>
      </div>
    );
  }

  if (!hedgeFund) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <p>No data available for {hedgefundName}.</p>
      </div>
    );
  }

  const navItems = [
      {label: "Hedge Funds", path: '/beta/hedgefunds'},
      {label: hedgeFund.name?.toUpperCase?.()}
  ]

  return (
      <Card bordered={false} style={showLogo?{backgroundImage: `url("${hedgeFund.logo}")`, backgroundSize: '250px auto', backgroundRepeat: 'no-repeat', backgroundPosition: 'center 70%'}:null}>
          <NavTrail items={navItems} extraRight={<Space>
              <Switch checked={showLogo} checkedChildren={'Hide Logo'} unCheckedChildren={'Show Logo'} onClick={()=>setShowLogo(!showLogo)}/>
          </Space>}/>
          <div className={'p-6'}>
              {hedgeFund.current_portfolio ? (
                  <HedgeFundTable portfolio={hedgeFund.current_portfolio}/>
              ) : (
                  <p>No portfolio data available.</p>
              )}
          </div>
      </Card>
  );
};

export default HedgeFund;
